// ClimatologyTemperatureForm.jsx
import { useState } from "react"
import { UniversalDropDown } from "@fileops/swmm-react"
import { Button } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Frame for Climatology Temperature inputs 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @returns UI for interactive swmm modeling.
 */
export default function ClimatologyTemperatureForm({model, setModel, fullModel}) {
  const [timeSeries, setTimeSeries] = useState(fullModel.TEMPERATURE.TIMESERIES?fullModel.TEMPERATURE.TIMESERIES:'')
  const [fileSource, setFileSource] = useState('')
  const [fileStart,  setFileStart ] = useState('')
  const [tempUnits,  setTempUnits ] = useState(fullModel.TEMPERATURE.FILE?fullModel.TEMPERATURE.Units?fullModel.TEMPERATURE.Units:'C10':'')
  const [timeSeriesSet, setTimeSeriesSet] = useState([...(Object.keys(fullModel.TIMESERIES).length===0?[]:Object.keys(fullModel.TIMESERIES))])
  const [temperatureSource, setTemperatureSource] = useState(fullModel.TEMPERATURE.TIMESERIES?'TIMESERIES':
                                                             fullModel.TEMPERATURE.FILE      ?'FILE': 
                                                             'NODATA')
  
  const handleChangeTimeSeries = val => {
    setTimeSeries(val)
    
    let TEMPERATURE = model.TEMPERATURE

    if(model){
      if(temperatureSource==='TIMESERIES' || val===''){
        TEMPERATURE.TIMESERIES = val

        setModel(prev => ({
          ...prev,
          TEMPERATURE: TEMPERATURE
        }))
      }
    }
  }
  
  const handleChangeFileSource = val => {
    setFileSource(val)
    
    let TEMPERATURE = model.TEMPERATURE

    if(model){
      if(temperatureSource==='FILE'){
        TEMPERATURE.FILE = val

        setModel(prev => ({
          ...prev,
          TEMPERATURE: TEMPERATURE
        }))
      }
    }
  }

  const handleChangeFileStart = val => {
    setFileStart(val)
    
    let TEMPERATURE = model.TEMPERATURE

    if(model){
      if(temperatureSource==='FILE'){
        TEMPERATURE.Start = val

        setModel(prev => ({
          ...prev,
          TEMPERATURE: TEMPERATURE
        }))
      }
    }
  }

  const handleChangeTempUnits = val => {
    setTempUnits(val)
    
    let TEMPERATURE = model.TEMPERATURE

    if(model){
      if(temperatureSource==='FILE'){
        TEMPERATURE.Units = val

        setModel(prev => ({
          ...prev,
          TEMPERATURE: TEMPERATURE
        }))
      }
    }
  }

  const handleChangeTemperatureSource = (val) => {
    setTemperatureSource(val)

    let TEMPERATURE = model.TEMPERATURE

    if(model){
      if(val==='NODATA'){
        delete TEMPERATURE.FILE
        delete TEMPERATURE.Start
        delete TEMPERATURE.Units
        delete TEMPERATURE.TIMESERIES
      }
      if(val==='TIMESERIES'){
        delete TEMPERATURE.FILE
        delete TEMPERATURE.Start
        delete TEMPERATURE.Units

        TEMPERATURE.TIMESERIES = timeSeries
      }
      if(val==='FILE'){
        delete TEMPERATURE.TIMESERIES

        TEMPERATURE.FILE = fileSource
        TEMPERATURE.Start = fileStart
        TEMPERATURE.Units = tempUnits
      }

      setModel(prev => ({
        ...prev,
        TEMPERATURE: TEMPERATURE
      }))
    }
  }

  return(
    <>
    {
      model.TEMPERATURE &&
      <>
      {(
        <div>
          <div style={{borderBottom:'3px solid #fff', paddingTop: '5px'}}>Source of Temperature Data</div>
          <label className='editor-small' >
            <input
              type="radio"
              checked={temperatureSource === 'NODATA'}
              onChange={()=>handleChangeTemperatureSource('NODATA')}
            />No Data
          </label>
          <label className='editor-small' >
            <input
              type="radio"
              checked={temperatureSource === 'TIMESERIES'}
              onChange={()=>handleChangeTemperatureSource('TIMESERIES')}
              />Time Series
          </label>
          
          <label className='editor-small' >Time Series
          <Button style={{padding: '0px', float:'right', display:'inline' }} onClick={()=>{handleChangeTimeSeries('')}}>CLEAR</Button>
            <UniversalDropDown style={{padding: '0'}}
              IDs={timeSeriesSet} 
              selectText={"Select a Time Series"} 
              value={timeSeries}
              onChange={(val)=>{handleChangeTimeSeries(val)}} >
            </UniversalDropDown>
          </label>

          <label className='editor-small' >
            <input
              type="radio"
              checked={temperatureSource === 'FILE'}
              onChange={()=>handleChangeTemperatureSource('FILE')}
              />External Climate File
          </label>
          <label className='editor-small' >
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{handleChangeFileSource(e.target.value)}}
                    value={model.TEMPERATURE.FILE?model.TEMPERATURE.FILE:''}
                    id={'ClimatologyTemperatureFile'}
            />
          </label>
          
          <label className='editor-small' >Start Reading File at
            <input  type = "text"
                    style={{width: '95%', display: 'flex'}}
                    onChange={(e)=>{handleChangeFileStart(e.target.value)}}
                    value={model.TEMPERATURE.Start?model.TEMPERATURE.Start:''}
                    id={'ClimatologyTemperatureFileStart'}
            />
          </label>
          </div>
        )}
        {(
          <div>
            <div style={{borderBottom:'3px solid #fff', paddingTop: '5px'}}>Temperature Units for GHCN Files</div>
            <label className='editor-small' >
              <input
                type="radio"
                checked={tempUnits === 'C10'}
                onChange={()=>handleChangeTempUnits('C10')}
              />Tenths of Degrees Celsius
            </label>
            <label className='editor-small' >
              <input
                type="radio"
                checked={tempUnits === 'C'}
                onChange={()=>handleChangeTempUnits('C')}
                />Degrees Celsius
              </label>
            <label className='editor-small' >
              <input
                type="radio"
                checked={tempUnits === 'F'}
                onChange={()=>handleChangeTempUnits('F')}
                />Degrees Fahrenheit
              </label>
            </div>
          )}
      </>
    }
    </>
  )
}